import * as React from "react"
import { PostItemCard, PostItemLink } from "./PostStyles"

const BlogItem = ({ node, index }) => {
  const { title, gatsbyPath, introduction } = node

  const body = (
    <>
      {typeof index === "number" && (
        <span className="card__index">{`0${index + 1}`}</span>
      )}
      <h4>{title}</h4>
      {introduction && <p>{introduction}</p>}
    </>
  )

  return gatsbyPath ? (
    <PostItemLink to={gatsbyPath}>{body}</PostItemLink>
  ) : (
    <PostItemCard>{body}</PostItemCard>
  )
}

export default BlogItem
